<template>
  <v-layout row justify-center>
   <v-navigation-drawer
      width="580"
      v-model="periodmodaloftransaction"
      fixed
      right
      clippe
    >
    <v-btn flat small class="green-darken-text font-roboto" @click="periodmodaloftransaction = false">
      <v-icon>close</v-icon>CLOSE
    </v-btn>
      <!-- <v-btn flat  icon @click="invoicemodal = false" class="green--text" dense>
        &nbsp;&nbsp;&nbsp;&nbsp;<v-icon>close</v-icon>
        close
      </v-btn> -->
      <v-spacer></v-spacer>
        <v-flex xs12>
          <p align="center" class="font-size-20-bold font-roboto">Transaction Detail</p>
        </v-flex>
        <v-layout>
          <v-flex xs12 md12 px-4>
            <span style="font-weight:bold;">Transaction Ref No.</span> &emsp;&emsp;
            <span class="green-darken-text">{{current_transref}}</span>
          </v-flex>
        </v-layout>

        <v-layout align-center justify-center row wrap>
          <v-flex xs11 py-4>
            <v-data-table
              :headers="tablelistheaders"
              :items="itemlistview"
              hide-actions
              class="elevation-1 font-roboto"
              id="tableDetail"
            >
              <template v-slot:items="props" >
                <tr >
                  <td data-label="Period No." class="text-xs-center">{{ props.item.period_no }}</td>
                  <td data-label="Start Date" class="text-xs-left" v-if="!mobileView">{{ formatDate(props.item.sv_period_start_date) }}</td>
                  <td data-label="Start Date" class="text-xs-right" v-if="mobileView">{{ formatDate(props.item.sv_period_start_date) }}</td>
                  <td data-label="End Date" class="text-xs-left" v-if="!mobileView">{{ formatDate(props.item.sv_period_end_date) }}</td>
                  <td data-label="End Date" class="text-xs-right" v-if="mobileView">{{ formatDate(props.item.sv_period_end_date) }}</td>
                  <td data-label="Invoice No." v-if="props.item.invoice_no" class="text-xs-left">{{ props.item.invoice_no }}</td>
                  <td data-label="Invoice No." v-else class="text-xs-center">-</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
        <v-flex pb-3></v-flex>
                  <v-layout align-center justify-end row wrap px-4>
            <v-flex xs10 py-3 px-4>
              <div class="font-size-14 font-roboto" align="right">
                <span>Total Amount (THB)</span> &nbsp;&nbsp;
                <br />
                <span>VAT (THB)</span> &nbsp;&nbsp;
                <br />
                <span>Withholding Tax (THB)</span> &nbsp;&nbsp;
                <br />
                <span>Fines (THB)</span> &nbsp;&nbsp;
                <br />
                <strong>Grand Total (THB) &nbsp;&nbsp;</strong>
              </div>
            </v-flex>
            <v-flex xs2 py-4>
              <div class="font-size-14 font-roboto" align="right">
                <span>{{ addCommas(tempwaitinglist.total_amount) }}</span>
                <br />
                <span>{{ addCommas(tempwaitinglist.total_vat_amount) }}</span>
                <br />
                <span >{{ addCommas(tempwaitinglist.total_wht)}}</span>
                <br />
                <span>{{ addCommas(tempwaitinglist.total_fines) }}</span>
                <br />
                <strong>{{addCommas(tempwaitinglist.total_pay_amount)}}</strong>
              </div>
            </v-flex>
          </v-layout>
    </v-navigation-drawer>
  </v-layout>
</template>

<script>
import { sync } from 'vuex-pathify'
import moment from 'moment'
moment.locale('en')
export default {
  data () {
    return {
      start_date: '',
      end_date: '',
      sub_total: 0.00,
      pay_amount: 0.00,
      vat_amount: 0.00,
      wht_amount: 0.00,
      wht_rate: '',
      summarydetail: [],
      svdetail: [],
      mobileView: false,
      dialogloader: true,
      notifications: false,
      sound: true,
      widgets: false,
      invoicedatail: { item_list: [] },
      tablelistheaders: [
        { text: 'Period No.', value: 'period_no', sortable: false, align: 'center' },
        { text: 'Start Date', value: 'sv_period_start_date', sortable: false, align: 'left' },
        { text: 'End Date', value: 'sv_period_end_date', sortable: false, align: 'left' },
        { text: 'Invoice No.', value: 'invoice_no', sortable: false, align: 'left' }
      ],
      paymenttoken: ''
    }
  },
  methods: {
    formatDate (date) {
      return moment(date).format('DD MMMM YYYY')
    },
    async getperioddetails () {
      try {
        if (this.current_transref) {
          var { data } = await this.axios.post(process.env.VUE_APP_APIHOST + '/transaction_period',
            { transRef: this.current_transref },
            { headers: { Authorization: this.$cookies.get('token') } }
          )
          this.svdetail = data
          this.dialogloader = false
        }
      } catch (error) {
        this.istableloading = false
        console.log(error.message)
      }
    },
    clearData () {
      // this.$cookies.cl
    },
    addCommas (nStr) {
      nStr += ''
      var x = nStr.split('.')
      var x1 = x[0]
      var x2 = x.length > 1 ? '.' + x[1] : ''
      var rgx = /(\d+)(\d{3})/
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2')
      }
      return x1 + x2
    },
    handleView () {
      this.mobileView = window.innerWidth <= 990
      this.$cookies.set('screenView', this.mobileView)
    }
  },
  computed: {
    periodmodaloftransaction: sync('periodmodaloftransaction'),
    current_transref: sync('current_transref'),
    tempwaitinglist: sync('tempwaitinglist'),
    itemlistview () {
      return this.svdetail.map(item => {
        return {
          ...item
          // grand_total: item.sv_amount_exclude_vat + item.vat_amount
        }
      })
    }
  },
  watch: {
    current_transref () {
      this.getperioddetails()
    }
  },
  created () {
    this.getperioddetails()
    this.dialogloader = false
    this.handleView()
  }
}
</script>

<style>
#tableDetail tr:nth-child(even){
    background-color: #f1fcf1;
  }
/* responsive */
@media(max-width: 500px){
  #tableDetail thead{
    display: none;
}
  #tableDetail tr:nth-child(even){
    background-color: #f1fcf1;
  }
  #tableDetail, #tableDetail tr, #tableDetail td{
    display: block;
    width: 100%;
  }
  #tableDetail tr, #tableDetail td{
    border:1px solid #ddd;
    text-align: center;
  }
  #tableDetail tr{
    margin-bottom: 15px;
  }
  #tableDetail td{
    overflow-wrap : break-word;
    display: inline-block;
    word-break: break-word;
    text-align: right;
    padding-left: 50%;
    position: relative;
    height:50px;
  }
   #tableDetail td.longtext{
     min-height: 40px;
     height:fit-content;
     word-break: break-word;
  }
  #tableDetail td::before{
    content: attr(data-label);
    position: absolute;
    left: 0;
    width: 40%;
    padding-left: 15px;
    font-size: 15px;
    font-weight: bold;
    text-align: left;
  }
}

</style>
